webpackJsonp([35783957827783],{

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/constructionSign.0aa31e58.png";

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(21);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _standardWrapper = __webpack_require__(27);
	
	var _standardWrapper2 = _interopRequireDefault(_standardWrapper);
	
	var _constructionSign = __webpack_require__(462);
	
	var _constructionSign2 = _interopRequireDefault(_constructionSign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConstructionSign = _styledComponents2.default.div.withConfig({
	  displayName: 'pages__ConstructionSign'
	})(['height:500px;width:500px;background-image:url(', ');background-size:contain;background-repeat:no-repeat;'], _constructionSign2.default);
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    _standardWrapper2.default,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Birkenstab',
	      meta: [{ name: 'keywords', content: 'birkenstab, birkenstab.de, homepage, personal website, website' }]
	    }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Hello I\'m Birkenstab'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This is my awesome website'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'It is still far from finished. The ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/stuff' },
	        'Stuff page'
	      ),
	      ' is the only one with content right now'
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/stuff' },
	      'Go to Stuff'
	    ),
	    _react2.default.createElement(ConstructionSign, { title: 'construction sign' }),
	    _react2.default.createElement(
	      'figcaption',
	      null,
	      'I drew this picture in 2010 :D'
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-dec417c9676874e41bde.js